module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-8fab7758aa4b71028dee6fbeb994a7f3.webp";